import React, { useState } from "react";
import axios from "axios";
import {
 Box,
 Typography,
 Button,
 Input,
 CircularProgress,
 Alert,
 Stack,
} from "@mui/material";

const ExcelUpload = ({ onUpload }) => {
 const [file, setFile] = useState(null);
 const [loading, setLoading] = useState(false);
 const [message, setMessage] = useState("");

 const handleFileChange = (e) => {
  setFile(e.target.files[0]);
  setMessage("");
 };

 const handleUpload = async () => {
  if (!file) return setMessage("❌ Please select a file first.");
  setLoading(true);
  setMessage("");

  const formData = new FormData();
  formData.append("file", file);

  try {
   const res = await axios.post(
    "https://app-api.carexpert.org.in/api/price/upload-excel",
    formData,
    {
     headers: {
      "Content-Type": "multipart/form-data",
     },
    },
   );
   setMessage(`✅ Upload Successful: ${res.data.message}`);
   setFile(null);
   if (onUpload) onUpload(); // 🔄 callback
  } catch (err) {
   console.error(err);
   setMessage("❌ Upload failed. Check console for details.");
  } finally {
   setLoading(false);
  }
 };

 return (
  <Box>
   <Stack direction="row" spacing={2} alignItems="center" flexWrap="wrap">
    <Button
     variant="outlined"
     color="secondary"
     href="/demo-car-price-upload-format.xlsx"
     download
    >
     📄 Demo Format
    </Button>

    <Input type="file" onChange={handleFileChange} />
    <Button variant="contained" color="primary" onClick={handleUpload}>
     {loading ? <CircularProgress size={20} color="inherit" /> : "Upload"}
    </Button>
   </Stack>

   {message && (
    <Alert
     severity={message.includes("❌") ? "error" : "success"}
     sx={{ mt: 1 }}
    >
     {message}
    </Alert>
   )}
  </Box>
 );
};

export default ExcelUpload;

// import React, { useState } from "react";
// import axios from "axios";
// import {
//  Box,
//  Typography,
//  Button,
//  Input,
//  CircularProgress,
//  Alert,
// } from "@mui/material";

// const ExcelUpload = () => {
//  const [file, setFile] = useState(null);
//  const [loading, setLoading] = useState(false);
//  const [message, setMessage] = useState("");

//  const handleFileChange = (e) => {
//   setFile(e.target.files[0]);
//   setMessage("");
//  };

//  const handleUpload = async () => {
//   if (!file) {
//    setMessage("❌ Please select a file first.");
//    return;
//   }

//   setLoading(true);
//   setMessage("");

//   const formData = new FormData();
//   formData.append("file", file);

//   try {
//    const res = await axios.post(
//     "https://app-api.carexpert.org.in/api/price/upload-excel", // ✅ your backend upload route
//     formData,
//     {
//      headers: {
//       "Content-Type": "multipart/form-data",
//      },
//     }
//    );
//    setMessage(`✅ Upload Successful: ${res.data.message}`);
//   } catch (err) {
//    console.error(err);
//    setMessage("❌ Upload failed. Check console for details.");
//   } finally {
//    setLoading(false);
//   }
//  };

//  return (
//   <Box
//    display="flex"
//    flexDirection="column"
//    gap={2}
//    sx={{
//     maxWidth: 400,
//     border: "1px solid #ccc",
//     p: 3,
//     borderRadius: 2,
//     mt: 4,
//    }}
//   >
//    <Typography variant="h6">📤 Upload Excel for Car Prices</Typography>

//    {/* ✅ Download Demo Format */}
//    <Button
//     variant="outlined"
//     color="secondary"
//     href="/demo-car-price-upload-format.xlsx"
//     download
//    >
//     📄 Download Demo Format
//    </Button>

//    <Input type="file" onChange={handleFileChange} />

//    <Button variant="contained" color="primary" onClick={handleUpload}>
//     {loading ? <CircularProgress size={24} color="inherit" /> : "Upload"}
//    </Button>

//    {message && (
//     <Alert severity={message.includes("❌") ? "error" : "success"}>
//      {message}
//     </Alert>
//    )}
//   </Box>
//  );
// };

// export default ExcelUpload;

// // import React, { useState } from "react";
// // import axios from "axios";
// // import {
// //  Box,
// //  Typography,
// //  Button,
// //  Input,
// //  CircularProgress,
// //  Alert,
// // } from "@mui/material";

// // const ExcelUpload = () => {
// //  const [file, setFile] = useState(null);
// //  const [loading, setLoading] = useState(false);
// //  const [message, setMessage] = useState("");

// //  const handleFileChange = (e) => {
// //   setFile(e.target.files[0]);
// //   setMessage("");
// //  };

// //  const handleUpload = async () => {
// //   if (!file) return setMessage("❌ Please select a file first.");
// //   setLoading(true);
// //   setMessage("");

// //   const formData = new FormData();
// //   formData.append("file", file);

// //   try {
// //    const res = await axios.post(
// //     "https://app-api.carexpert.org.in/api/price/upload-excel", // ✅ replace with your correct API
// //     formData,
// //     {
// //      headers: {
// //       "Content-Type": "multipart/form-data",
// //      },
// //     }
// //    );
// //    setMessage(`✅ Upload Successful: ${res.data.message}`);
// //   } catch (err) {
// //    console.error(err);
// //    setMessage("❌ Upload failed. Check console for details.");
// //   } finally {
// //    setLoading(false);
// //   }
// //  };

// //  return (
// //   <Box
// //    display="flex"
// //    flexDirection="column"
// //    gap={2}
// //    sx={{ maxWidth: 400, border: "1px solid #ccc", p: 3, borderRadius: 2 }}
// //   >
// //    <Typography variant="h6">📤 Upload Excel for Car Prices</Typography>
// //    <Input type="file" onChange={handleFileChange} />
// //    <Button variant="contained" color="primary" onClick={handleUpload}>
// //     {loading ? <CircularProgress size={24} color="inherit" /> : "Upload"}
// //    </Button>
// //    {message && (
// //     <Alert severity={message.includes("❌") ? "error" : "success"}>
// //      {message}
// //     </Alert>
// //    )}
// //   </Box>
// //  );
// // };

// // export default ExcelUpload;
